export default __webpack_public_path__ + "static/media/msg-ico.88e0c6ca.svg";